/* global axios */
import ApiClient from './ApiClient';

class PlanAPI extends ApiClient {
  constructor() {
    super('billing', { accountScoped: true });
  }

  getPlan() {
    return axios.get(this.url);
  }

  upgrade(payload) {
    return axios.post(`${this.url}/upgrade`, payload);
  }

  enforcement() {
    return axios.get(`${this.url}/enforcement`);
  }
}

export default new PlanAPI();
